import moment from 'moment';
import {
  lensPath,
  lensProp,
  mergeDeepLeft,
  mergeLeft,
  over,
} from 'ramda';
import actions from '../actions';
import { ASYNC_FETCH_INITIAL_STATE, makeAsyncFetchReducer, makeReducer } from '../utils';

export const INITIAL_STATE = {
  orders: {
    ...ASYNC_FETCH_INITIAL_STATE,
    total    : 0,
    retrieved: 0,
    data     : [],
    filters  : {
      filtered: [],
      page    : 0,
      pageSize: 10,
      sorted  : [],
      from    : moment()
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
        .valueOf(),
      to: moment()
        .hours(23)
        .minutes(59)
        .seconds(59)
        .milliseconds(0)
        .valueOf(),
    },
  },
};
const reducer = makeReducer({
  initialState: INITIAL_STATE,
  reducers    : {
    ...makeAsyncFetchReducer({
      initialState: INITIAL_STATE.orders,
      key         : 'orders',
      init        : [actions.orders.fetch.type, over(lensProp('orders'), mergeLeft({
        loading: true,
        error  : null,
      }))],
      success: [actions.orders.fetchSuccess.type, (state, {
        payload: {
          orders,
          ...rest
        },
      }) => mergeDeepLeft({
        orders: {
          ...rest,
          data   : orders,
          loading: false,
        },
      }, state)],
      error: actions.orders.fetchError.type,
    }),
    [actions.orders.setFilters.type]: (state, { payload }) => over(
      lensPath(['orders', 'filters']), mergeLeft(payload), state
    ),
  },
});

export default reducer;
